import {store} from "../App";
import moment from "moment/moment";
import {storeAuthorizationJsonFromLocalStorage} from "../settings/actions/application-actions";
import {applicationHistory} from "./application-history";
import {getAuthorizationToken, refreshExpiredAuthToken} from '../common/request';

export const checkIfCurrentAuthTokenIsExpired = expirationDate => moment().isAfter(expirationDate);

export const clearLocalStorageAndRedirectToCas = () => {
    window.localStorage.clear();
    window.location = `${process.env.REACT_APP_CAS_URL}&redirect_uri=${window.location.origin}/my/albums%3Fts%3D` + new Date().getTime();
};

export const refreshIfTokenIsExpired = async authState => {
    if (checkIfCurrentAuthTokenIsExpired(authState.expirationDate)) {
        if (authState.refresh_token) {
            try {
                const refreshResponse = await refreshExpiredAuthToken(authState.refresh_token);
                const {access_token} = refreshResponse;
                const expirationDate = moment().add(authState.expires_in, 's').format();
                const authorizationState = {...refreshResponse, expirationDate, refresh_token: authState.refresh_token};
                window.localStorage.setItem('authorization_token', access_token);
                window.localStorage.setItem('authorizationState', JSON.stringify(authorizationState));
                return store.dispatch(storeAuthorizationJsonFromLocalStorage(authorizationState));
            } catch (err) {
                console.log(err);
                // If the refresh call fails in some way then the refresh token is bad or expired so
                // redirect to CAS and get a new OC token
                clearLocalStorageAndRedirectToCas();
                return err;
            }
        }
        return 'not expired';
    }
};

export const checkForOcToken = async location => {
    if (location && location.search) {

        const ocToken = location.search.match(/code=([^&]+)/);
        if (ocToken != null && ocToken.length > 0) {
            try {
                const apiResponse = await getAuthorizationToken(ocToken[1]);
                if (apiResponse.error) {
                    throw apiResponse;
                }
                const {access_token, expires_in} = apiResponse;
                const expirationDate = moment().add(expires_in, 's').format();
                const authorizationState = {...apiResponse, expirationDate};
                window.localStorage.setItem('authorization_token', access_token);
                window.localStorage.setItem('authorizationState', JSON.stringify(authorizationState));
                window.localStorage.setItem('initialLoginRefresh','true');
                store.dispatch(storeAuthorizationJsonFromLocalStorage(authorizationState));
                return applicationHistory.push(location.pathname);
            } catch (err) {
                window.localStorage.setItem('ocTokenFailed', 'true');
                console.log(err);
                return err;
            }
        } else {
            // no oc token in this url so
            window.localStorage.setItem('ocTokenFailed', 'false');
            console.log("checkForOcToken - no token found in " + location.search);
            throw {error: "no token found"}
        }
    }
};

export const checkTokenRedirect = location => {
    return checkForOcToken(location).then(data => {
        const token = window.localStorage.getItem('authorization_token');
        const ocTokenResErr = data === 'error' || data === 'token';

        // this will be populated if there was a bad response from the api trying to exchange this for an auth token
        const hasOcTokenFailed = window.localStorage.getItem('ocTokenFailed');

        if (!ocTokenResErr || (token !== 'undefined' && token !== '' && token)) {
            const authTokenObject = JSON.parse(window.localStorage.getItem('authorizationState'));
            return refreshIfTokenIsExpired(authTokenObject).then(() => {
                store.dispatch(storeAuthorizationJsonFromLocalStorage(JSON.parse(window.localStorage.getItem('authorizationState'))));
                return true;
            }).catch(err => err);
        } else if (!hasOcTokenFailed) {
            // redirect to CAS
            let redirectLocation = window.location;
            if (window.location == window.location.origin) {
                redirectLocation = window.location.origin + "/my/albums%3Fts%3D" + new Date().getTime();
            }
            const authorizationLocation = `${process.env.REACT_APP_CAS_URL}&redirect_uri=${redirectLocation}`
            window.location = authorizationLocation;
        } else {
            // this is to stop the oc token loop that can happen when the secret is bad and in some other cases
            window.location = `${window.location.origin}/error/500`;
        }
    }).catch(err => {
        console.log(err);
        if (localStorage.getItem('ocTokenFailed') !== 'true') {
            let redirectLocation = window.location;
            if (window.location == window.location.origin) {
                redirectLocation = window.location.origin + "/my/albums%3Fts%3D" + new Date().getTime();
            }
            const authorizationLocation = `${process.env.REACT_APP_CAS_URL}&redirect_uri=${redirectLocation}`
            window.location = authorizationLocation;
        }
    });
};



// WEBPACK FOOTER //
// ./src/common/authorizationHelpers.js